import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossDeltaLinkedFetch } from './actions';

export const sagasReportGrossDeltaLinked = [
  takeLatest(actionReportGrossDeltaLinkedFetch.rejected, workerErrorNotifyThunk),
];
